// extracted by mini-css-extract-plugin
export default {"Container":"ToggleMenu_Container__yByqo","Icon":"ToggleMenu_Icon__rmRpf","append-animate":"ToggleMenu_append-animate__qmlAh"};